import { Row } from 'antd';


const CFRow = (props) => {
  return <Row {...props} />;
};

export default CFRow;